import React from "react";
import { Link } from "react-router-dom";

const ConfirmedSubUserEmail = () => {
  return (
    <div className="login-container">
      <h4 style={{ color: "green" }}>
        Your Email has been confirmed successfully!
      </h4>
      <Link
        to={{
          pathname: "/login",
        }}
        className="btn btn-info mt-4"
      >
        Go to login page
      </Link>
    </div>
  );
};

export { ConfirmedSubUserEmail };
